export const PROFILE_OCCUPATIONS = [
  "physician",
  "healthcare_assistant",
] as const;

export type ProfileOccupation = (typeof PROFILE_OCCUPATIONS)[number];

export const PROFILE_SALUTATIONS = ["Úr", "Hölgy"] as const;
export type ProfileSalutation = (typeof PROFILE_SALUTATIONS)[number];

export const PROFILE_NAME_TITLES = ["Dr.", "Prof. Dr."] as const;
export type ProfileNameTitle = (typeof PROFILE_NAME_TITLES)[number];

export const PROFILE_OCCUPATION_LABELS: Record<ProfileOccupation, string> = {
  physician: "Orvos",
  healthcare_assistant: "Egészségügyi asszisztens",
};

export const PHYSICIAN_TITLES = [
  "Háziorvos",
  "Házi gyermekorvos",
  "Vegyes praxis orvosa",
  "Helyettesítő orvos",
  "Egyéb orvos",
] as const;

export const ASSISTANT_TITLES = [
  "Egészségügyi asszisztens",
  "Praxisasszisztens",
  "Szakápoló / nővér",
  "Szakdolgozó",
  "Egyéb szakdolgozó",
] as const;

export const REGISTRY_PATTERN = /^[0-9A-Za-z./-]{4,20}$/;

export function isProfileOccupation(
  value: string | null | undefined,
): value is ProfileOccupation {
  return PROFILE_OCCUPATIONS.includes(value as ProfileOccupation);
}

export function isProfileSalutation(
  value: string | null | undefined,
): value is ProfileSalutation {
  return PROFILE_SALUTATIONS.includes(value as ProfileSalutation);
}

export function isProfileNameTitle(
  value: string | null | undefined,
): value is ProfileNameTitle {
  return PROFILE_NAME_TITLES.includes(value as ProfileNameTitle);
}

export function titlesForOccupation(occupation: ProfileOccupation) {
  return occupation === "physician" ? PHYSICIAN_TITLES : ASSISTANT_TITLES;
}

export function registryLabel(occupation: ProfileOccupation | null) {
  if (occupation === "healthcare_assistant") {
    return "Működési nyilvántartási szám";
  }
  return "Orvosi pecsétszám";
}

export function registryHint(occupation: ProfileOccupation | null) {
  if (occupation === "healthcare_assistant") {
    return "Opcionális. A működési nyilvántartási azonosító, ha van.";
  }
  return "Működési nyilvántartási / orvosi pecsétszám.";
}

export type ProfileVisibility = "public" | "private";

export const PROFILE_VISIBILITY_LABELS: Record<ProfileVisibility, string> = {
  public: "Publikus",
  private: "Privát",
};

export type OwnProfile = {
  id: string;
  email: string | null;
  fullName: string;
  lastName: string | null;
  firstName: string | null;
  salutation: ProfileSalutation | null;
  nameTitle: ProfileNameTitle | null;
  professionalTitle: string | null;
  occupation: ProfileOccupation | null;
  phone: string | null;
  city: string | null;
  bio: string | null;
  registryNumber: string | null;
  avatarPath: string | null;
  accountStatus: "pending" | "active" | "suspended" | "banned" | "anonymized";
  profileVisibility: ProfileVisibility;
};

export type ProfileUpdateInput = {
  lastName: string;
  firstName: string;
  salutation: ProfileSalutation;
  nameTitle: ProfileNameTitle | "";
  occupation: ProfileOccupation;
  professionalTitle: string;
  phone: string;
  city: string;
  bio: string;
  registryNumber: string;
  profileVisibility: ProfileVisibility;
};
